import React, { useState, useEffect, useContext } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  StyleSheet,
  Pressable,
  Platform,
  Keyboard,
} from "react-native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import {
  createStackNavigator,
  CardStyleInterpolators,
} from "@react-navigation/stack";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { TouchableOpacity } from "react-native";

import { useSafeAreaInsets } from "react-native-safe-area-context";
import Splash from "../Splash/splash";
import Signin from "../Signin/signin";
import SignUp from "../signup/signup";
import Subscription from "../subscription/subscription";
import Home from "../home/home";
import Graph from "../graphAndAchievments/graph";
import Ebook from "../ebook/ebook";
import Faq from "../Faq/faq";
import Account from "../account/account";
import ForgotPassword from "../forgotpassword/forgotpassword";
import ResetPassword from "../resetpassword/resetpassword";
import VerifyEmail from "../verifyemail/verifyemail";
import PasswordVerify from "../passwordverify/passwordverify";
import Pdfview from "../pdfviewer/pdfview";
import Bulksubscription from "../bulksubscription/bulksubscription";
import BlogScreen from "../blogscreen/blogscreen";
import Products from "../products/products";
import News from "../news/news";
import { COLORS, FONTS } from "../../../utils";
import MySubscripion from "../mySubscription copy/MySubscripion";
import UpgradeSubscription from "../mySubscription copy/UpgradeSubscription";
import UpgradeBulksubscription from "../mySubscription copy/UpgradeBulkSubscription";
import SquareSvg from "../../components/SquareSvg";
import { HomeIcon } from "../../assets/Icons/Tabs/HomeIcon";
import { AccountIcon } from "../../assets/Icons/Tabs/AccountIcon";
import { FAQIcon } from "../../assets/Icons/Tabs/FAQIcon";
import { ProductIcon } from "../../assets/Icons/Tabs/ProductIcon";
import { EBookIcon } from "../../assets/Icons/Tabs/EBookIcon";
import { NewsIcon } from "../../assets/Icons/Tabs/NewsIcon";
import { useTranslation } from "react-i18next";
import Notification from "../notification/notification";
import { DataContext } from "../../components/DataContext";
import servererror from "../../assets/images/servererror.png";
import ProductRequest from "../products/ProductRequest";
import ProductChat from "../products/ProductChat";
import useData from "../../hooks/useData";
import useAuth from "../../hooks/useAuth";
import { AddFcmToken, getUserProfile } from "../../apiCall/userApiCall";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import SubscribeModal from "../../components/SubscribeModal";



const Stack = createStackNavigator();
const Tab = createBottomTabNavigator();


// Reset Language Button
function ResetLanguageButton() {
  const handleReset = async () => {
    await AsyncStorage.removeItem("Language");
  };
  return (
    <TouchableOpacity onPress={handleReset} style={{ marginRight: 15 }}>
      <Text style={{ color: "blue", fontWeight: "bold" }}>Reset</Text>
    </TouchableOpacity>
  );
}

// HOC to protect stack screens
const ProtectedScreen = ({ children, navigation }) => {
  const { isTrial, isSubscribed } = useAuth();

  useEffect(() => {
    if (!isTrial && !isSubscribed) {
      navigation.replace("Home2");
    }
  }, [isTrial, isSubscribed]);

  return children;
};


// MyTabs with conditional access
const MyTabs = () => {
  const { t } = useTranslation();
  const [isLandscape, setIsLandscape] = useState(false);
  const {
    isAuthenticated,
    token,
    userId,
    isTrial,
    setIsTrial,
    isSubscribed,
    setIsSubscribed,
    isLoggedIn,
saveUserDetails
  } = useAuth();
  const navigation = useNavigation();
const isFocused = useIsFocused()
  // Fetch user profile
useEffect(()=>{
  if(isFocused){
    AddFcmToken()
    saveUserDetails()

  }
},[isFocused])

  // Orientation listener
  useEffect(() => {
    const updateOrientation = () => {
      const { width, height } = Dimensions.get("window");
      setIsLandscape(width > height && height < 500);
    };
    updateOrientation();
    const subscription = Dimensions.addEventListener("change", updateOrientation);
    return () => subscription?.remove();
  }, []);

  return (
    <Tab.Navigator
      tabBar={(props) => (
        <MyTabBar {...props} isLandscape={isLandscape} t={t} isSubscribed={isSubscribed} />
      )}
      screenOptions={{
        tabBarStyle: {
          maxWidth: Platform.OS === "web" ? 700 : "100%",
          padding: 10,
        },
      }}
    >
      {/* Home always accessible */}
      <Tab.Screen
        name="Home"
        component={Home}
        options={{ headerShown: false, tabBarLabel: t("Home") }}
      />

      {/* Other tabs always visible but disabled if not subscribed */}
      <Tab.Screen
        name="Products"
        component={Products}
        options={{ headerShown: false, tabBarLabel: t("Products") }}
      />
      <Tab.Screen
        name="News"
        component={News}
        options={{ headerShown: false, tabBarLabel: t("News") }}
      />
      <Tab.Screen
        name="Ebook"
        component={Ebook}
        options={{ headerShown: false, tabBarLabel: t("Ebook") }}
      />
      <Tab.Screen
        name="Faq"
        component={Faq}
        options={{ headerShown: false, tabBarLabel: t("Faq") }}
      />
      <Tab.Screen
        name="Account"
        component={Account}
        options={{ headerShown: false, tabBarLabel: t("Account") }}
      />
    </Tab.Navigator>
  );
};


// Custom TabBar
const MyTabBar = ({ state, descriptors, navigation, isLandscape, t, isSubscribed }) => {
  const insets = useSafeAreaInsets();
  const [modalVisible, setModalVisible] = React.useState(false);
  // 🔹 Restricted tabs
  const restrictedTabs = ["Products", "News", "Ebook", "Faq"];

  return (
    <View
      style={[
        isLandscape ? styles.verticalTabBar : styles.horizontalTabBar,
        {
          paddingBottom: insets.bottom > 0 ? insets.bottom : 10,
          height: (Platform.OS === "ios" ? 60 : 55) + insets.bottom,
        },
      ]}
    >
      {state.routes.map((route, index) => {
        if (route.name !== "Graph") {
          const { options } = descriptors[route.key];
          const label =
            options.tabBarLabel !== undefined
              ? options.tabBarLabel
              : options.title !== undefined
                ? options.title
                : route.name;

          const isFocused = state.index === index;

          const onPress = () => {
            Keyboard.dismiss();

            // 🔹 If user not subscribed and tab is restricted
            if (!isSubscribed && restrictedTabs.includes(route.name)) {

              setModalVisible(true);
              return; // 🚫 Don't navigate
            }

            const event = navigation.emit({
              type: "tabPress",
              target: route.key,
              canPreventDefault: true,
            });

            if (!isFocused && !event.defaultPrevented) {
              navigation.navigate(route.name);
            }
          };

          let TabIconComponent;
          switch (route.name) {
            case "Home": TabIconComponent = HomeIcon; break;
            case "Products": TabIconComponent = ProductIcon; break;
            case "News": TabIconComponent = NewsIcon; break;
            case "Ebook": TabIconComponent = EBookIcon; break;
            case "Faq": TabIconComponent = FAQIcon; break;
            case "Account": TabIconComponent = AccountIcon; break;
            default: TabIconComponent = AccountIcon; break;
          }

          const color =
            isFocused
              ? COLORS.primary
              : (!isSubscribed && restrictedTabs.includes(route.name) ? "gray" : "gray");

          return (
            <Pressable
              key={route.name}
              onPress={onPress}
              style={isLandscape ? styles.verticalTabItem : styles.horizontalTabItem}
            >
              <SquareSvg Icon={TabIconComponent} size={25} color={color} />
              <Text
                maxFontSizeMultiplier={1.04}
                style={{
                  color,
                  fontFamily: FONTS.PoppinsMedium,
                  fontSize: 12,
                  letterSpacing: 0.9,
                }}
              >
                {label}
              </Text>
            </Pressable>
          );
        }
      })}
      <SubscribeModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onSubscribe={() => {
          setModalVisible(false);
          navigation.navigate("Subscription"); 
        }}
      />
    </View>
  );
};




// AppNavigator
const AppNavigator = () => {
  const { error } = useContext(DataContext);
  const { isTrial, isSubscribed ,showSubscriptioModal,setShowSubscriptionModal} = useAuth();
  const navigation = useNavigation()
  

  return (
<>
    <Stack.Navigator
      screenOptions={{
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        headerRight: () => <ResetLanguageButton />
      }}
    >
      <Stack.Screen name="Splash" component={Splash} options={{ headerShown: false }} />
      <Stack.Screen name="Signin" component={Signin} options={{ headerShown: false }} />
      <Stack.Screen name="SignUp" component={SignUp} options={{ headerShown: false }} />
      <Stack.Screen name="Subscription" component={Subscription} options={{ headerShown: false }} />
      <Stack.Screen name="Bulksubscription" component={Bulksubscription} options={{ headerShown: false }} />
      <Stack.Screen name="Notification" component={Notification} options={{ headerShown: false }} />
      <Stack.Screen name="productRequest" component={ProductRequest} options={{ headerShown: false }} />
      
      <Stack.Screen
        name="MySubscripion"
        component={MySubscripion}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="UpgradeSubscription"
        component={UpgradeSubscription}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="UpgradeBulksubscription"
        component={UpgradeBulksubscription}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="ForgotPassword"
        component={ForgotPassword}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="VerifyEmail"
        component={VerifyEmail}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="ResetPassword"
        component={ResetPassword}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="PasswordVerify"
        component={PasswordVerify}
        options={{ headerShown: false }}
      />
      
      <Stack.Screen
        name="Home2"
        component={MyTabs}
        options={{ headerShown: false }}
      />

      {/* Protected Screens */}
      <Stack.Screen name="Graph" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <Graph {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen>

      <Stack.Screen name="Ebook" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <Ebook {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen>

      <Stack.Screen name="Faq" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <Faq {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen>

      <Stack.Screen name="Account" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <Account {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen>

      {/* <Stack.Screen name="Bulksubscription" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <Bulksubscription {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen> */}

      <Stack.Screen name="BlogScreen" options={{
        headerShown: false,
        presentation: "transparentModal",
      }}
      >
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <BlogScreen {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen>


      <Stack.Screen name="News" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <News {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen>
 

      <Stack.Screen name="Products" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <Products {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen>

      {/* <Stack.Screen name="productRequest" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <ProductRequest {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen> */}

      <Stack.Screen name="productChat" options={{ headerShown: false }}>
        {props => (
          <ProtectedScreen navigation={props.navigation}>
            <ProductChat {...props} />
          </ProtectedScreen>
        )}
      </Stack.Screen>

      {/* Other screens that are not subscription protected */}
      {/* ... Add your other screens like ForgotPassword, ResetPassword, etc. */}

    </Stack.Navigator>

    <SubscribeModal
        visible={showSubscriptioModal}
        onClose={() => setShowSubscriptionModal(false)}
        onSubscribe={() => {
          setShowSubscriptionModal(false);
          navigation.navigate("Subscription"); // ya apka subscription screen
        }}
      />

</>
  );
};


export default AppNavigator;


// Styles
const styles = StyleSheet.create({
  horizontalTabBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#FCFCFC",
    padding: Platform.OS === "web" ? 8 : 5,
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: Platform.OS === "ios" ? 75 : 60,
    zIndex: 10,
    maxWidth: 700,
    alignItems: "center",
    margin: "auto",
  },
  verticalTabBar: {
    flexDirection: "column",
    justifyContent: "space-around",
    backgroundColor: "#FCFCFC",
    padding: 8,
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    width: 75,
    zIndex: 10,
  },
  horizontalTabItem: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    minWidth: "15.75%",
  },
  verticalTabItem: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
});
